(function(){
    'use strict';

    angular.module('dataHandlingConditionWebsiteActivity', ['ngAnimate', 'journey.canvas.srv'])
        .controller('conditionWebsiteActivityCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', '$interval',  conditionWebsiteActivityCtrl]);

    function conditionWebsiteActivityCtrl($scope, $rootScope, $timeout, canvasService, helpers, $interval){
        $scope.displayWebsiteActivityConditionOptions = false;
        $scope.errorUrl = false;
        $scope.displayForm = true;

        function resetNode () {
            $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.test');
            $scope.trackingTestClass = '';
            $scope.displayWebsiteActivityConditionOptions = false;
            $scope.errorUrl = false;
        }

        $scope.specificUrlOptions = [
            {
                value: 'any-tracked-page',
                message: $scope.translate('canvas.entry.websiteEngagement.anyTracked')
            },
            {
                value: 'is-url',
                message: $scope.translate('canvas.entry.websiteEngagement.specificUrl')
            },
            {
                value: 'contains-url',
                message: $scope.translate('canvas.entry.websiteEngagement.containsUrl')
            },
            {
                value: 'doesnotcontain-url',
                message: $scope.translate('canvas.entry.websiteEngagement.not.containsUrl')
            },
            {
                value: 'startswith-url',
                message: $scope.translate('canvas.entry.websiteEngagement.starts.with.url')
            },
            {
                value: 'endswith-url',
                message: $scope.translate('canvas.entry.websiteEngagement.ends.with.url')
            },
            {
                value: 'wildcardmatch-url',
                message: $scope.translate('canvas.entry.websiteEngagement.wildcard.url')
            }
        ];

        $rootScope.$on('displayConditionWebsiteActivityModal', function(evt, conn, showTip) {
            var entry = document.getElementById(conn.id).getBoundingClientRect();

            $scope.top = entry.top;
            $scope.left = entry.left;
            $scope.entryTop = entry.top;

            $scope.displayWebsiteActivityConditionOptions = false;
            $scope.errorUrl  = false;
            $scope.displayForm = true;

            $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.test');

            $scope.showTip = showTip;

            $scope.trackingTestClass = '';
            $scope.modalPos = $scope.calculateModalPos($scope.top, $scope.left);
            $scope.displayWebsiteActivityConditionOptions = true;

            $scope.connections = angular.copy(conn);

            $(window).resize(function() {
                var entry = document.getElementById($scope.connections.id).getBoundingClientRect();
                $scope.$apply(function()  {
                    $scope.top = entry.top;
                    $scope.left = entry.left;
                    $scope.calculateModalPos($scope.top, $scope.left);
                });
            });
        });

        $rootScope.$on('hideConditionWebsiteActivityModal', function() {
            resetNode();
        });


        $rootScope.$on('displayConditionWebsiteActivityModalError', function() {
            $scope.errorUrl = true;
        });

        $scope.calculateModalPos = function(top, left) {
            var currentTopPercent = ((top/window.innerHeight) * 100);
            var currentLeftPercent = ((left/window.innerWidth) * 100);
            var fixedHeight = 400;
            var fixedwidth = 450;

            if((left + 160) > window.innerWidth) {
                currentLeftPercent = 20;
                left = 0;
            }

            $scope.modalTop = ( currentTopPercent + _calculateTopByPos()).toFixed(0) + '%';
            $scope.modalLeft = ( currentLeftPercent + _calculateLeftByPos()).toFixed(0) + '%';


            function _calculateTopByPos() {
                var totalTop = top + fixedHeight,
                    resTop = 0;

                if(totalTop > window.innerHeight) {
                    resTop = -38;
                }

                return resTop;
            }

            function _calculateLeftByPos() {
                var totalLeft = left + fixedwidth,
                    resLeft = 14;

                if($scope.showTip) {
                    resLeft = 22;
                }

                if(totalLeft > window.innerWidth) {
                    resLeft = -20;
                }

                return resLeft;
            }
        };

        $scope.displayTrackerModal = () => {
            $rootScope.$emit('displayTrackerModal');
        };

        $scope.parseDescription = function (desc, specificUrl) {
            if(!$scope.connections) return;

            if (specificUrl) {
                if(!$scope.connections.data) return;

                if (desc) {
                    var arrLen = desc.split("");
                    arrLen = arrLen.length;
                    if (arrLen > 20) {
                        return desc.slice(0, 22) + '...';
                    } else {
                        return desc;
                    }
                } else if ($scope.connections.data.source === 'contains-url') {
                    return $scope.translate('canvas.entry.websiteEngagement.containsUrl');
                } else {
                    return $scope.translate('canvas.condition.websiteActivity.specificUrl');
                }
            } else {
                if (desc) {
                    desc = $scope.translate('canvas.condition.websiteActivity.anyTracked');
                } else {
                    return $scope.translate('commons.enterDetails');
                }
                return desc;
            }
        };

        let stop, intents = 0;
        $scope.testUrl = function() {
            if ($scope.connections.data.specificUrl) {
                $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.checking');
                $scope.trackingTestClass = 'checking-url';
                let testUrl = $scope.connections.data.specificUrl + '?apTestApi=true&url=' + encodeURIComponent($scope.connections.data.specificUrl);
                if(/^http:\/\//i.test(testUrl)) {
                    window.open(testUrl , '_blank');
                } else {
                    document.getElementsByName('testSiteIFrame')[0].onerror = () => {
                        window.open(testUrl , '_blank');
                    };

                    document.getElementsByName('testSiteIFrame')[0].src = testUrl;

                }
                stop = $interval(() => {
                    canvasService.testTracker($scope.connections.data.specificUrl).then(function (result) {
                        if(result.data.TestTrackerInformation.IsInstalled) {
                            $interval.cancel(stop);
                            $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.confirm');
                            $scope.trackingTestClass = 'url-confirm';
                            intents = 0;
                        } else if(intents >= 4) {
                            $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.notDetected');
                            $scope.trackingTestClass = 'url-fail';
                            $interval.cancel(stop);
                            intents = 0;
                        }
                        intents ++;
                    }).catch(function() {
                        $scope.trackingTestState = $scope.translate('canvas.entry.websiteEngagement.url.notDetected');
                        $scope.trackingTestClass = 'url-fail';
                        $interval.cancel(stop);
                        intents = 0;
                    });
                }, 2000);
            } else {
                $scope.$emit('errorMsg', $scope.translate('canvas.entry.websiteEngagement.url.error'), 'error');
            }
        };

        $scope.$watch('connections.data.specificUrl', function (url) {
            if (url && ($scope.connections.data.source === 'is-url' || $scope.connections.data.source === 'wildcardmatch-url')) {
                var reg;

                if ($scope.connections.data.source === 'is-url') {
                    reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
                } else {
                    reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+\/\*$/;
                }

                if (!reg.test(url)) {
                    $scope.$parent.specificUrlError = true;
                } else {
                    $scope.$parent.specificUrlError = false;
                }
            }
        });

        $scope.$watch('connections.data.source', function (old, newVal) {
            if (newVal === 'any-tracked-page') {
                $scope.connections.data.specificUrl = '';
                $scope.append = false;
            }

            if(old != newVal) {
                $scope.errorUrl = false;
                $scope.append = false;
            }
        });

        //Cancel Button
        $scope.cancel = function () {
            resetNode();

            var node = _.find($rootScope.connections, function (conn) {
                return conn.id === $scope.connections.id;
            });

            if (!node) {
                // Execute listener when user cancel the web site activity node
                $rootScope.$broadcast('deleteWebSiteActivityNode' + $scope.connections.id);
            }
        };

        $scope.save = function() {
            Intercom('trackEvent', 'AP - WebsiteActivity');
            $rootScope.$emit('saveConditionWebsiteActivityData' + $scope.connections.id, $scope.connections, $scope.errorUrl);
        };
    };
})();



// WEBPACK FOOTER //
// ./app/controllers/modals/conditionWebsiteActivityController.js